'use strict';

bbw.directive.bbwPostEditorControls = ['bbw.LayoutTypeSvc', function(bbwLayoutTypeSvc) {

    var defaults = {
        'addPhotos': true,
        'submit': null
    };

    return {
        scope: {
            'postEditor': '=editor'
        },
        transclude: true,
        templateUrl: bbw.templateUrl('post-editor-controls.html'),
        link: function(scope, element, attrs) {
            var editor = scope.postEditor;
            if (angular.isUndefined(editor) || !(editor instanceof bbw.service.PostEditor)) {
                throw new Error('bbw.service.PostEditor required');
            }
            scope.controls = scope.$parent.$eval(attrs.bbwPostEditorControls);
            var updateEntityScope = function() {
                scope.entityData = editor.entity ? editor.entity._data : undefined;
            };
            updateEntityScope();
            scope.$watch('postEditor.entity', function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    updateEntityScope();
                }
            });
            if (!angular.isObject(scope.controls)) {
                scope.controls = {};
            }
            angular.forEach(defaults, function(value, key) {
                if (angular.isUndefined(scope.controls[key])) {
                    scope.controls[key] = value;
                }
            });
        }
    }

}];
